module.exports = __webpack_public_path__ + "img/aws.b7eadcc7.png";